module.exports = __webpack_public_path__ + "static/media/supertaster.ef6bb47c.svg";